import LinkButtonComponent, {
  LinkButtonProps,
} from "../../../button/link/link-button.component";
import { FC } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type TableLinkButtonProps = Omit<LinkButtonProps, "children"> & {
  icon: IconDefinition;
};

const TableLinkButtonComponent: FC<TableLinkButtonProps> = ({
  type = "brand",
  ...props
}) => {
  return (
    <LinkButtonComponent
      type={type}
      {...props}
      classNames={{
        root: classNames("table_button", props.classNames?.root),
        content: "table_button__content",
      }}
    >
      <FontAwesomeIcon
        icon={props.icon}
        className="table_button__icon"
        size={"sm"}
      />
    </LinkButtonComponent>
  );
};

export default TableLinkButtonComponent;
